export default {
  methods: {
    getErrors(errorResponse) {
      const errors = errorResponse?.data?.errors || { server_validation_failure: true };

      return Object.keys(errors)
        .map(fieldName => {
          const key = `validation_error_${fieldName}`;
          return this.$te(key)
            ? this.$t(key)
            : this.$t('server_validation_failure');
        });
    },
  },
};
